import { ServerConfig } from "@/config/config";
import { downloadBlob } from "@/utils/blob";
import { Axios } from "./auth-service";

export class MainProfilingServiceClass {
	public readonly URL = `${ServerConfig.mainAppHost}/pprof`

	public async getHeap():Promise<void>{
		let result = await Axios.get(`${this.URL}/heap`, {responseType: "blob"});
		let blob = new Blob([result.data], {type: "application/gzip"});
		downloadBlob(blob, "heap.tar.gz");
	}

	public async getGoRoutine():Promise<void>{
		let result = await Axios.get(`${this.URL}/goroutine`, {responseType: "blob"});
		let blob = new Blob([result.data], {type: "application/gzip"});
		downloadBlob(blob, "goroutine.tar.gz");
	}

	public async getCPU():Promise<void>{
		let result = await Axios.get(`${this.URL}/cpu`, {responseType: "blob"});
		let blob = new Blob([result.data], {type: "application/gzip"});
		downloadBlob(blob, "cpu.tar.gz");
	}

	public async gc():Promise<void>{
		await Axios.post(`${this.URL}/gc`);
	}

}

export const MainProfilingService = new MainProfilingServiceClass();